const lazyLoadAutocomplete = async () => {
  await import(/* webpackChunkName: "jquery.zipAutocomplete" */ '@static/js/light/vendor/jquery.zipAutocomplete');
  await import(/* webpackChunkName: "job-search-autocomplete" */ '@zr/common/js/jquery-plugins/job-search-autocomplete');
  await import(/* webpackChunkName: "autocomplete-css" */ '@seo/css/partials/header/_autocomplete.less');
};

const lazyLoadAutocompleteZDS = async () => {
  await import(/* webpackChunkName: "jquery.zipAutocomplete" */ '@static/js/light/vendor/jquery.zipAutocomplete');
  await import(/* webpackChunkName: "autocomplete" */ './header-zds/_autocomplete');
  await import(/* webpackChunkName: "autocomplete-css" */ '@seo/css/partials/header/header-zds/_autocomplete.less');
};

// $('[data-type="search"], [data-type="location"]').one('focus', () => lazyLoadAutocomplete());
if (zr.page.model.isZDS) {
  lazyLoadAutocompleteZDS();
} else {
  lazyLoadAutocomplete();
}
